/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * event
 * @export
 * @interface GetCharactersCharacterIdCalendar200Ok
 */
export interface GetCharactersCharacterIdCalendar200Ok {
    /**
     * event_date string
     * @type {Date}
     * @memberof GetCharactersCharacterIdCalendar200Ok
     */
    eventDate?: Date;
    /**
     * event_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdCalendar200Ok
     */
    eventId?: number;
    /**
     * event_response string
     * @type {string}
     * @memberof GetCharactersCharacterIdCalendar200Ok
     */
    eventResponse?: GetCharactersCharacterIdCalendar200OkEventResponseEnum;
    /**
     * importance integer
     * @type {number}
     * @memberof GetCharactersCharacterIdCalendar200Ok
     */
    importance?: number;
    /**
     * title string
     * @type {string}
     * @memberof GetCharactersCharacterIdCalendar200Ok
     */
    title?: string;
}


/**
 * @export
 */
export const GetCharactersCharacterIdCalendar200OkEventResponseEnum = {
    Declined: 'declined',
    NotResponded: 'not_responded',
    Accepted: 'accepted',
    Tentative: 'tentative'
} as const;
export type GetCharactersCharacterIdCalendar200OkEventResponseEnum = typeof GetCharactersCharacterIdCalendar200OkEventResponseEnum[keyof typeof GetCharactersCharacterIdCalendar200OkEventResponseEnum];


/**
 * Check if a given object implements the GetCharactersCharacterIdCalendar200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdCalendar200Ok(value: object): value is GetCharactersCharacterIdCalendar200Ok {
    return true;
}

export function GetCharactersCharacterIdCalendar200OkFromJSON(json: any): GetCharactersCharacterIdCalendar200Ok {
    return GetCharactersCharacterIdCalendar200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdCalendar200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdCalendar200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'eventDate': json['event_date'] == null ? undefined : (new Date(json['event_date'])),
        'eventId': json['event_id'] == null ? undefined : json['event_id'],
        'eventResponse': json['event_response'] == null ? undefined : json['event_response'],
        'importance': json['importance'] == null ? undefined : json['importance'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function GetCharactersCharacterIdCalendar200OkToJSON(json: any): GetCharactersCharacterIdCalendar200Ok {
    return GetCharactersCharacterIdCalendar200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdCalendar200OkToJSONTyped(value?: GetCharactersCharacterIdCalendar200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_date': value['eventDate'] == null ? undefined : ((value['eventDate']).toISOString()),
        'event_id': value['eventId'],
        'event_response': value['eventResponse'],
        'importance': value['importance'],
        'title': value['title'],
    };
}

